import React from 'react';
import './About.css'; // スタイルシートをインポート

function About() {
  return (
    <section className="wrapper back About">
      <h3 className="h3">今しかない、この文字で<br/>世界に1つだけのカレンダー</h3>
      <div className="lead">
        <p className="lead_item">ちょっとずつ覚えた数字、<br />まだ練習中の文字、<br />いつの間にか上手に書けるように...</p>
        <p>何歳になっても、<span className="bold">今しかないこの文字</span>を<br />カレンダーにして残そう。</p>
      </div>
    </section>
  );
}

export default About;
